<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        :auto-size-cell="true"
        :row-multi-select-with-click="true"
        class="agGrid"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteLanguage"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify"
        class="btn primary small"
        @click="updateLanguageView"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>
    <!-- <el-col class="bottom-btns-container">
      <el-button type="primary" @click="dialogFormVisible = true">
        Thêm ngôn ngữ
      </el-button>
      <el-button type="danger" @click="deleteLanguage">
        Xóa ngôn ngữ
      </el-button>
    </el-col> -->
    <el-dialog
      :title="!isEdit ? 'Thêm ngôn ngữ' : 'Sửa ngôn ngữ'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã ngôn ngữ</div>
                  <validation-provider
                    rules="required|max:20"
                    name="Mã ngôn ngữ"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        :disabled="isEdit"
                        type="text"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label required">Mô tả</div>
                  <validation-provider
                    rules="required|max:100"
                    name="Mô tả ngôn ngữ"
                  >
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateLanguage"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small outline" @click="addLanguage">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import {
  getLanguageListApi,
  addCodeApi,
  updateCodeApi,
  deleteCodeApi
} from '@/api/common/code'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      isDisableModify: false,
      isDisableDelete: false,
      loading: false,
      defaultForm: {
        id: null,
        p_code: 'LANG',
        code: '',
        desc: ''
      },
      form: {
        id: null,
        p_code: 'LANG',
        code: '',
        desc: ''
      },
      titlePopup: 'Thêm ngôn ngữ',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC'
      },
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
          // cellStyle: {'padding-left': '12px'}
        },
        {
          sortable: false,
          headerName: 'Mã ngôn ngữ',
          field: 'code',
          width: 100
        },
        {
          headerName: 'Mô tả',
          sortable: false,
          field: 'desc'
          // cellRenderer: 'CellRenderTextInput',
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  },

  mounted() {
    this.attachData()
  },
  methods: {
    async attachData() {
      // bus.$emit("startLoader", { msg: "" });
      this.loading = true
      let data = await getLanguageListApi()
      // bus.$emit("endLoader");
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }
    },
    async addLanguage() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addCodeApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async updateLanguage() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateCodeApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteLanguage() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteLanguageConfirm'), () => {
          deleteCodeApi({
            ids: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },

    updateLanguageView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        this.isEdit = false
      } else {
        this.titlePopup = 'Sửa ngôn ngữ'
        this.isEdit = true
        const rowData = rowsSelected[0]
        this.form.code = rowData.code
        this.form.desc = rowData.desc
        this.form.id = rowData.id
        this.dialogFormVisible = true
      }
    },
    resetItemInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
